'use client';

import { FC, useState, useEffect } from 'react';
import Chart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';
import { useAuth } from '../context/AuthContext';
import { API_URL } from '../constants';

interface AnalyticsData {
    subscribers: number;
    totalEarnings: number;
    postsCount: number;
    likesCount: number;
    monthlyData: {
        month: string;
        subscribers: number;
        earnings: number;
    }[];
}

const Analytics: FC = () => {
    const [analyticsData, setAnalyticsData] = useState<AnalyticsData | null>(null);
    const [loading, setLoading] = useState(true);
    const { user, token } = useAuth();

    useEffect(() => {
        if (user?.role === 'creator') {
            fetchAnalytics();
        }
    }, [user, token]);

    const fetchAnalytics = async () => {
        try {
            const response = await fetch(`${API_URL}/api/analytics`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setAnalyticsData(data);
            }
        } catch (error) {
            console.error('Failed to fetch analytics:', error);
        } finally {
            setLoading(false);
        }
    };

    const [series] = useState([
        {
            name: 'Subscribers',
            data: analyticsData?.monthlyData?.map(d => d.subscribers) || [0, 5, 12, 25, 32, 45, 58, 67, 73, 84, 91, 96],
        },
        {
            name: 'Earnings (SOL)',
            data: analyticsData?.monthlyData?.map(d => d.earnings) || [0, 2, 8, 15, 22, 30, 38, 42, 48, 55, 61, 68],
        },
    ]);

    const [chartOptions] = useState<ApexOptions>({
        chart: {
            type: 'bar',
            height: 250,
            stacked: true,
            toolbar: {
                show: false,
            },
        },
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0,
                    },
                },
            },
        ],
        plotOptions: {
            bar: {
                horizontal: false,
            },
        },
        legend: {
            show: false,
        },
        fill: {
            opacity: 1,
        },
    });

    return (
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <h1 className="display-1 text-grey-900 fw-700">Analytics - Coming Soon</h1>
        </div>
    );
};

export default Analytics;
